<template>
<div>
    <div class="container">
        <div class="show">
            <span class="showname">姓名：{{acceptdata.name}}<br><br></span>
            <div class="detail">
                单位：{{acceptdata.company}}<br>
                职位：{{acceptdata.job}}<br>
                微信：{{acceptdata.wechat}}<br>
                手机：{{acceptdata.phone}}<br>
                邮箱：{{acceptdata.email}}<br>
                联系地址：{{acceptdata.address}}
            </div>
        </div>
    </div>
</div>    
</template>
  
<script>
import $ from 'jquery'
export default {
  data () {
    return {
      id: 0,
      acceptdata: ''
    }
  },
  mounted () {
    const vm = this
    vm.id = this.$route.query.id
    $.ajax({
      type: 'GET',
      url: '/v1/qrGenerate/qrIDcard',
      data: {id: vm.id},
      dataType: 'json',
      success: function (response) {
        vm.acceptdata = response.data
      }
    })
  }
}
</script>

<style>
.show{
    height: 400px;
    margin-left: 10%;
    margin-right: 10%;
    padding: 80px;
    background-color: #fff;
    background-image: url("../../assets/img/idcardbackground.jpg");
    background-size: 100% 130%;
    -moz-background-size: 100% 100%;
    font-size: 25px;
    font-weight: bold;
}
.showname{
    font-size: 40px;
}
.detail{
    margin-left: 40%;
}
</style>
